import React, { useState, useEffect, useCallback ,useRef} from "react";
import DropDownButton from "devextreme-react/drop-down-button";
import data from "../../assets/apiRoutes.json";
import { connect } from "react-redux";
import "devextreme/data/odata/store";
import { GridLayout } from "../../common/GridLayout";
import { Localization } from "../../common/Localization";
import {
  Column,
  DataGrid,
  GroupPanel,
  SearchPanel,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnFixing,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import axios from "axios";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
const LocationForReceipt = (props) => {
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  const [locationData, setLocationData] = useState([]);
  const [location, setLocation] = useState({
    locationcode: "",
    locationtype: "",
    dimensions: "",
    description: "",
    classcode: "",
  });
  const [currentLayout, setCurrentLayout] = useState("Default");

  const [loading, setLoading] = useState("Data Loading");
  const loadLocationdata = () => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.LocationDetail}?id=${props.id}&locid=${props.lotid}`, //locid is lot id here
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setLocationData(res.data);
        if (locationData && locationData.length == 0)
          setLoading("No Data Found");
      })
      .catch((err) => {
        console.log(err, "err in load location");
        setLoading("No Data Found");
      });
  };
  useEffect(() => {
    loadLocationdata();
  }, []);
  const buttonDropDownOptions = { width: 140 };

  // tabs handling
  const [currentTab, setCurrentTab] = useState(3);
  const changeCurrentTab = (e) => {
    setCurrentTab(e.tab);
    var request = {
      value: e.itemData.tab,
      id: e.itemData.rowId,
    };
    props.changeTab(request);
  };

  const { classcode, locationcode, locationtype, description, dimensions } =
    location;
  const onInputChange = (e) => {
    setLocation({ ...location, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    await axios.post(
      `${window._env_.REACT_APP_APIS}/api/WmLocation/SaveLocation`,
      location
    );
    alert("Location information has been saved successfully!");
    setLocation({
      classcode: "",
      locationtype: "",
      dimensions: "",
      description: "",
      locationcode: "",
    });
  };
  const allowedPageSizes = [5, 10, 20, "all"];

  const gridKey = "1dbd9d45-a1fc-48eb-9f19-4f026f88b233";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  return (
    <div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        noDataText={loading}
        dataSource={locationData}
        showBorders={true}
        className={props?.SearchPanelAccordionStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
        hoverStateEnabled={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
      >
        <Column dataField="rowid" caption="" cellRender={(rowid) => cellRender(rowid)} />
        <ColumnChooser enabled={true} />
        <ColumnFixing enabled={true} />
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting visible={true} mode="multiple" />
        <LoadPanel enabled={false} />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <HeaderFilter visible={true} />
        <GroupPanel visible={true} />
        <SearchPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Column dataField="locationcode" caption={Localization.formatMessage('IMLOCATION.LOCATIONCODE', 'Location Code')}></Column>
        <Column dataField="locationtype" caption={Localization.formatMessage('IMLOCATION.LOCATIONTYPE', 'Location Type')}></Column>
        <Column dataField="warehousecode" caption="Warehouse"></Column>
        <Column dataField="sublotcode" ccaption={Localization.formatMessage('IMSUBLOT.SUBLOTCODE', 'Sublot Code')}></Column>
        <Toolbar>
          <Item location="after">
            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
  function cellRender(rowid) {
    return (
      <DropDownButton
        className="dropdownWithoutText"
        dropDownOptions={buttonDropDownOptions}
        items={[
          { name: "Lots", tab: 0, rowId: rowid.data.rowid },
        ]}
        displayExpr="name"
        onItemClick={(e) => changeCurrentTab(e)}
        keyExpr="rowId"
      />
    );
  }
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(LocationForReceipt);
